import { useAuth } from '~/composables/useAuth'
import { useCurrentLocation } from '~/composables/useCurrentLocation'
import { useCurrentUser } from '~/composables/useCurrentUser'
import { useMfaInfo } from '~/composables/useMfaInfo'
import { useOrganization } from '~/composables/useOrganization'

export default defineNuxtRouteMiddleware(async (to, _) => {
  const { recheckSession } = useAuth()
  await recheckSession()

  const { hasRequiredAal, aal, pendingUser } = useMfaInfo()

  if (aal.value !== 'unauthenticated') {
    // app初期化時にsupabase.client.ts pluginでロード済み
    // pendingUserが存在すれば初期セットアップ未実施。
    // 初期セットアップ未実施の場合はセットアップ画面へ転送
    if (pendingUser.value) {
      if (to.name === 'auth-setup') return

      return navigateTo({
        name: 'auth-setup',
      })
    }
  }

  // 未ログイン状態の場合はlogin画面に転送
  // 未ログイン状態 = MFA要件を満たしていない
  if (!hasRequiredAal.value && to.name !== 'login') {
    return navigateTo({
      name: 'login',
      query: {
        redirect: to.path,
        redirectQuery: JSON.stringify(to.query),
      },
    })
  }

  // ログイン状態の場合
  if (hasRequiredAal.value) {
    // ログイン済みで /login にアクセスした場合はリダイレクト
    if (to.name === 'login') {
      const { redirect, redirectQuery }: { redirect?: string; redirectQuery?: string } = to.query
      if (redirect && redirect !== '/login') {
        return navigateTo({ path: redirect, query: JSON.parse(redirectQuery ?? '{}') })
      }
      return navigateTo({ name: 'index' })
    }

    // その他stateを必要に応じて復元
    const { currentUser, recoverUser } = useCurrentUser()
    const { organization, recoverOrganization } = useOrganization()
    const { currentLocationId, recoverLocationId } = useCurrentLocation()

    if (!currentUser.value) {
      await recoverUser()
    }

    if (!organization.value) {
      await recoverOrganization()
    }

    if (!currentLocationId.value) {
      const userLocationId = currentUser.value?.locations[0]?.id ?? null
      await recoverLocationId(userLocationId)
    }
  }
})
